const getCookie = (name: string): string | null => {
  // SSR-safe: no document during Gatsby server render.
  if (typeof document === "undefined") return null;
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()!.split(";").shift()!;
  return null;
};

export default getCookie;
